import { css } from '@emotion/css';
import { Pagination, PaginationProps, Stack, Typography } from '@mui/material';
import * as React from 'react';

import { Divider } from '@/components/Divider';
import { COLORS } from '@/styles/tokens/colors';

export interface EdgeLabelPaginatedCardsProps {
  cards: JSX.Element[];
  index: number;
  setIndex: (index: number) => void;
}

const paginationClasses: NonNullable<PaginationProps['classes']> = {
  ul: css({
    // Hides the numbered page buttons so just the arrow controls are visible
    '> li:not(:first-child):not(:last-child)': {
      display: 'none',
    },
  }),
};

export const EdgeLabelPaginatedCards = ({
  cards,
  index,
  setIndex,
}: EdgeLabelPaginatedCardsProps): JSX.Element => {
  if (cards.length === 0) return <></>;
  if (cards.length === 1 && cards[0]) return cards[0];

  const currentPage = index + 1;
  const childCount = cards.length;

  // Create a handler that stops propagation
  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    // Stop the event from bubbling up to the edge
    event.stopPropagation();
    setIndex(page - 1);
  };

  // Add a click handler for the entire component
  const handleContainerClick = (event: React.MouseEvent) => {
    // Prevent clicks within the pagination cards from triggering edge click
    event.stopPropagation();
  };

  return (
    <Stack gap={2} onClick={handleContainerClick}>
      <Stack
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        height="1rem"
      >
        <Typography variant="body-xs">
          Event {currentPage} of {childCount}
        </Typography>
        <Pagination
          size="small"
          shape="rounded"
          classes={paginationClasses}
          count={childCount}
          page={currentPage}
          onChange={handlePageChange}
        />
      </Stack>
      <Divider sx={{ borderColor: COLORS.GRAY[200] }} />
      {cards[index]}
    </Stack>
  );
};
